import { Injectable } from '@angular/core';
var MapsAPILoader = /** @class */ (function () {
    function MapsAPILoader() {
    }
    MapsAPILoader.decorators = [
        { type: Injectable },
    ];
    return MapsAPILoader;
}());
export { MapsAPILoader };
//# sourceMappingURL=maps-api-loader.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/node_modules/@agm/core/services/maps-api-loader/maps-api-loader.js
// module id = ../../../../@agm/core/services/maps-api-loader/maps-api-loader.js
// module chunks = vendor